import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Milestone } from '@app/models/milestone';

const API = environment.API;
@Injectable({
  providedIn: 'root'
})
export class MilestoneService {
  constructor(private http: HttpClient) {}

  get(FollowId?: number) {
    const query = FollowId ? `?FollowId=${FollowId}` : '';
    return this.http.get<Milestone[]>(`${API}milestones${query}`);
  }

  create(milestone: Partial<Milestone>) {
    return this.http.post<Milestone>(`${API}milestones`, milestone);
  }

  getStatuses() {
    return this.http.get(`${API}milestones/statuses`);
  }
}
